import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCalendarAlt = function SvgCalendarAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#calendar-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M6.5 13.537a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3zM17.5 13.537a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3zM12.002 13.537a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3zM6.5 19.035a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3zM17.5 19.035a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3zM12.002 19.035a1.5 1.5 0 100-3.001 1.5 1.5 0 000 3z"
  }), React.createElement("path", {
    d: "M20.308 3.059h-2.31V1.037a1.001 1.001 0 10-1.998 0v2.022H8.005V1.037a1.002 1.002 0 00-2 0v2.022H3.693C1.646 3.059 0 4.851 0 7.057v12.98c0 2.21 1.65 3.997 3.692 3.997h16.616c2.041 0 3.692-1.792 3.692-3.998V7.056c0-2.205-1.66-3.997-3.692-3.997zm1.693 16.977c0 1.1-.757 1.999-1.693 1.999H3.692c-.94 0-1.693-.898-1.693-1.999V7.056c0-1.1.757-1.998 1.693-1.998h2.31v1.98a1.002 1.002 0 001.998 0V5.034h7.995v1.98a1.002 1.002 0 002 0v-1.98h2.308c.941 0 1.694.899 1.694 2L22 20.035z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "calendar-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgCalendarAlt;